import { render, staticRenderFns } from "./NominateTalentToClientModal.vue?vue&type=template&id=5d574816"
import script from "./NominateTalentToClientModal.vue?vue&type=script&lang=js"
export * from "./NominateTalentToClientModal.vue?vue&type=script&lang=js"
import style0 from "./NominateTalentToClientModal.vue?vue&type=style&index=0&id=5d574816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports